import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import fontawesome from "@fortawesome/fontawesome";
import { faArrowLeft, faChevronUp, faChevronDown, faMobile, faLocationArrow, faClock, faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

fontawesome.library.add(faArrowLeft, faChevronUp, faChevronDown, faMobile, faLocationArrow, faClock, faTimes)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false

// eslint-disable-next-line no-unused-vars
import ky from '@/network'
new Vue({
  router,
  store,
  data(){
    return {
      ready: false
    }
  },
  async created(){
    await this.$store.dispatch("getSession");
    await this.$store.dispatch("getShopInfo");
    await this.$store.dispatch("getSettings");
    this.ready = true;
    this.$store.dispatch("getCategories")
    this.$store.dispatch("getProducts")
    if(this.$store.getters.enableCheckout)await this.$store.dispatch("getCart")
    this.$store.dispatch("getStoreGallery");
    this.$store.dispatch("getDocuments")
  },
  render(h){return this.ready ? h(App) : h()}
}).$mount('#app')
